import styled from "@emotion/styled";
import { Flex, Typography } from "@ugc-ui/lego";

export const TitleContainer = styled(Flex)`
  width: 100%;
  height: 44px;
  margin-bottom: 24px;
`;

export const TypographyTitle = styled(Typography)`
  width: calc(100% - 40px); // 16px padding + 24px иконка = 40px
  text-align: center;
`;
